var exports = {
  "aw": "ForkPickerButtonContent__hiE7ZQ",
  "TG": "repoIconContainer__dxfFmV",
  "vl": "repoNameContainer__m7k1W3",
  "np": "repoNameText__3_F3-t",
};

module.exports = exports;
